import React from "react";

import { ScrollArea, Table, createStyles } from "@mantine/core";

import { useState } from "react";
import { useSelector } from "react-redux";
import FacilityTableRow from "../FacilityTableRow";
import RecordNotFound from "../RecordNotFound";
import TableLoader from "../TableLoader";

const useStyles = createStyles((theme) => ({
  header: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    borderRadius: "16px",
    transition: "box-shadow 150ms ease",
    // borderTopLeftRadius:'1rem',
    // borderTopRightRadius:'1rem',
    "& th": {
      backgroundColor: "#fff",
      color: "#000 !important",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0
    }
  },
  tbl:{
    borderRadius:'.5rem !important',
    borderCollapse : "separate",
    overflow:'hidden'
  },
  scrollBg:{
    backgroundColor: "#fff",
    padding:'1rem .5rem',
    borderRadius:'1rem',

    // "& .mantine-b6zkvl": {
    //   borderRadius:'1rem',
    //   overflow:'hidden !important'
    // }
  },
  scrolled: {
    boxShadow: theme.shadows.sm
  },
  notFoundText: {
    color: "#A8A8A8",
    fontFamily: "Inter",
    fontSize: "22px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal"
  }
}));

const FacilityTable = ({ facilities }) => {
  const { classes, cx } = useStyles();
  const { loading } = useSelector((state) => state.facility);
  const [scrolled, setScrolled] = useState(false);
  const rows = facilities?.map((row, i) => (
    <FacilityTableRow row={row} index={i} />
  ));

  return (
    <div style={{ marginTop: "30px" }} >
      <div style={{ fontSize:'1.3rem' , fontWeight:600 ,margin:".5rem 0" }} >All Facilities</div>

      <ScrollArea
        onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
        className={cx(classes.scrollBg )}
      >
        
        <Table
          // withColumnBorders
          // highlightOnHover
          withBorder
          enablestickyheader
          sx={{ fontFamily: "Inter"}}
          className={classes.tbl}
          fontSize={"sm"}
          verticalSpacing={"md"}
        >
          <thead className={cx(classes.header, { [classes.scrolled]: scrolled })}>
            <tr>
              <th style={{ minWidth: "200px", width:"15%"  }}>Facility Name</th>
              <th style={{ minWidth: "140px", width:"15%"  }}>Facility Type</th>
              <th style={{ minWidth: "50px" , width:"30%" }}>Address</th>
              <th style={{ minWidth: "20px" , width:"10%" }}>Zipcode</th>
              <th style={{ minWidth: "20px" , width:"7%" }}>State</th>
              <th style={{ minWidth: "50px" , width:"20%" }}>Phone Number</th>
              <th style={{ minWidth: "140px", width:"3%"  }}>Action</th>
            </tr>
          </thead>
          {loading ? (
            <tr>
              <td colSpan={1000}>
                <TableLoader />
              </td>
            </tr>
          ) : rows?.length ? (
            <tbody>{rows}</tbody>
          ) : (
            <tr>
              <td colSpan={1000}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "space-evenly",
                    height: "100vh",
                    gap: "8rem"
                  }}
                >
                  <RecordNotFound />
                  <p className={classes.notFoundText}>
                    You don&apos;t have any record, click on “Add New Facility”
                  </p>
                </div>
              </td>
            </tr>
          )}
        </Table>
      </ScrollArea>
    </div>
  );
};

export default FacilityTable;
